if (!ArrayBuffer.prototype.slice) {
  ArrayBuffer.prototype.slice = function (start, end) {
      var that = new Uint8Array(this);
      if (end == undefined) end = that.length;
      var result = new ArrayBuffer(end - start);
      var resultArray = new Uint8Array(result);
      for (var i = 0; i < resultArray.length; i++)
          resultArray[i] = that[i + start];
      return result;
  }
}

// Modified 08/11/21 for Rollup
!function(e){self.exifParser=e()}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

// when used in node, this will actually load the util module we depend on
// versus loading the builtin util module as happens otherwise
// this is a bug in node module loading as far as I am concerned
var util = _dereq_('util/');

var pSlice = Array.prototype.slice;
var hasOwn = Object.prototype.hasOwnProperty;

// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  }
  else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = stackStartFunction.name;
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function replacer(key, value) {
  if (util.isUndefined(value)) {
    return '' + value;
  }
  if (util.isNumber(value) && (isNaN(value) || !isFinite(value))) {
    return value.toString();
  }
  if (util.isFunction(value) || util.isRegExp(value)) {
    return value.toString();
  }
  return value;
}

function truncate(s, n) {
  if (util.isString(s)) {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}

function getMessage(self) {
  return truncate(JSON.stringify(self.actual, replacer), 128) + ' ' +
         self.operator + ' ' +
         truncate(JSON.stringify(self.expected, replacer), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

function _deepEqual(actual, expected) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (util.isBuffer(actual) && util.isBuffer(expected)) {
    if (actual.length != expected.length) return false;

    for (var i = 0; i < actual.length; i++) {
      if (actual[i] !== expected[i]) return false;
    }

    return true;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!util.isObject(actual) && !util.isObject(expected)) {
    return actual == expected;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b) {
  if (util.isNullOrUndefined(a) || util.isNullOrUndefined(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b);
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b),
        key, i;
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key])) return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  } else if (actual instanceof expected) {
    return true;
  } else if (expected.call({}, actual) === true) {
    return true;
  }

  return false;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (util.isString(expected)) {
    message = expected;
    expected = null;
  }

  try {
    block();
  } catch (e) {
    actual = e;
  }

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  if (!shouldThrow && expectedException(actual, expected)) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws.apply(this, [true].concat(pSlice.call(arguments)));
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/message) {
  _throws.apply(this, [false].concat(pSlice.call(arguments)));
};

assert.ifError = function(err) { if (err) {throw err;}};

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

},{"util/":3}],2:[function(_dereq_,module,exports){
module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}
},{}],3:[function(_dereq_,module,exports){
(function (process,global){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = _dereq_('./support/isBuffer');

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = _dereq_('inherits');

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

}).call(this,_dereq_("C:\\Users\\employee.COMPANYNAME\\AppData\\Roaming\\npm\\node_modules\\browserify\\node_modules\\insert-module-globals\\node_modules\\process\\browser.js"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./support/isBuffer":2,"C:\\Users\\employee.COMPANYNAME\\AppData\\Roaming\\npm\\node_modules\\browserify\\node_modules\\insert-module-globals\\node_modules\\process\\browser.js":5,"inherits":4}],4:[function(_dereq_,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}

},{}],5:[function(_dereq_,module,exports){
// shim for using process in browser

var process = module.exports = {};

process.nextTick = (function () {
    var canSetImmediate = typeof window !== 'undefined'
    && window.setImmediate;
    var canPost = typeof window !== 'undefined'
    && window.postMessage && window.addEventListener
    ;

    if (canSetImmediate) {
        return function (f) { return window.setImmediate(f) };
    }

    if (canPost) {
        var queue = [];
        window.addEventListener('message', function (ev) {
            var source = ev.source;
            if ((source === window || source === null) && ev.data === 'process-tick') {
                ev.stopPropagation();
                if (queue.length > 0) {
                    var fn = queue.shift();
                    fn();
                }
            }
        }, true);

        return function nextTick(fn) {
            queue.push(fn);
            window.postMessage('process-tick', '*');
        };
    }

    return function nextTick(fn) {
        setTimeout(fn, 0);
    };
})();

process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];

function noop() {}

process.on = noop;
process.once = noop;
process.off = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
}

// TODO(shtylman)
process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};

},{}],6:[function(_dereq_,module,exports){
var Parser = _dereq_('./lib/parser');

function getGlobal() {
    return self;
}

module.exports = {
    create: function(buffer, global) {
        global = global || getGlobal();
        if(buffer instanceof global.ArrayBuffer) {
            var DOMBufferStream = _dereq_('./lib/dom-bufferstream');
            return new Parser(new DOMBufferStream(buffer, 0, buffer.byteLength, true, global));
        } else {
            var NodeBufferStream = _dereq_('./lib/bufferstream');
            return new Parser(new NodeBufferStream(buffer, 0, buffer.length, true));
        }
    }
};
},{"./lib/bufferstream":7,"./lib/dom-bufferstream":8,"./lib/parser":12}],7:[function(_dereq_,module,exports){
function BufferStream(buffer, offset, length, bigEndian) {
    this.buffer = buffer;
    this.offset = offset || 0;
    length = typeof length === 'number' ? length : buffer.length;
    this.endPosition = this.offset + length;
    this.setBigEndian(bigEndian);
}

BufferStream.prototype = {
    setBigEndian: function(bigEndian) {
        this.bigEndian = !!bigEndian;
    },
    nextUInt8: function() {
        var value = this.buffer.readUInt8(this.offset);
        this.offset += 1;
        return value;
    },
    nextInt8: function() {
        var value = this.buffer.readInt8(this.offset);
        this.offset += 1;
        return value;
    },
    nextUInt16: function() {
        var value = this.bigEndian ? this.buffer.readUInt16BE(this.offset) : this.buffer.readUInt16LE(this.offset);
        this.offset += 2;
        return value;
    },
    nextUInt32: function() {
        var value = this.bigEndian ? this.buffer.readUInt32BE(this.offset) : this.buffer.readUInt32LE(this.offset);
        this.offset += 4;
        return value;
    },
    nextInt16: function() {
        var value = this.bigEndian ? this.buffer.readInt16BE(this.offset) : this.buffer.readInt16LE(this.offset);
        this.offset += 2;
        return value;
    },
    nextInt32: function() {
        var value = this.bigEndian ? this.buffer.readInt32BE(this.offset) : this.buffer.readInt32LE(this.offset);
        this.offset += 4;
        return value;
    },
    nextFloat: function() {
        var value = this.bigEndian ? this.buffer.readFloatBE(this.offset) : this.buffer.readFloatLE(this.offset);
        this.offset += 4;
        return value;
    },
    nextDouble: function() {
        var value = this.bigEndian ? this.buffer.readDoubleBE(this.offset) : this.buffer.readDoubleLE(this.offset);
        this.offset += 8;
        return value;
    },
    nextBuffer: function(length) {
        var value = this.buffer.slice(this.offset, this.offset + length);
        this.offset += length;
        return value;
    },
    remainingLength: function() {
        return this.endPosition - this.offset;
    },
    nextString: function(length) {
        var value = this.buffer.toString('ascii', this.offset, this.offset + length);
        this.offset += length;
        return value;
    },
    mark: function() {
        var self = this;
        return {
            openWithOffset: function(offset) {
                offset = (offset || 0) + this.offset; // Removed character.
                return new BufferStream(self.buffer, offset, self.endPosition - offset, self.bigEndian);
            },
            offset: this.offset
        };
    },
    offsetFrom: function(marker) {
        return this.offset - marker.offset;
    },
    skip: function(amount) {
        this.offset += amount;
    },
    branch: function(offset, length) {
        length = typeof length === 'number' ? length : this.endPosition - (this.offset + offset);
        return new BufferStream(this.buffer, this.offset + offset, length, this.bigEndian);
    }
};

module.exports = BufferStream;
},{}],8:[function(_dereq_,module,exports){
/*jslint browser: true, devel: true, bitwise: false, debug: true, eqeq: false, es5: true, evil: false, forin: false, newcap: false, nomen: true, plusplus: true, regexp: false, unparam: false, sloppy: true, stupid: false, sub: false, todo: true, vars: true, white: true */

function DOMBufferStream(arrayBuffer, offset, length, bigEndian, global, parentOffset) {
    this.global = global;
    offset = offset || 0;
    length = length || (arrayBuffer.byteLength - offset);
    this.arrayBuffer = arrayBuffer.slice(offset, offset + length);
    this.view = new global.DataView(this.arrayBuffer, 0, this.arrayBuffer.byteLength);
    this.setBigEndian(bigEndian);
    this.offset = 0;
    this.parentOffset = (parentOffset || 0) + offset;
}

DOMBufferStream.prototype = {
    setBigEndian: function(bigEndian) {
        this.littleEndian = !bigEndian;
    },
    nextUInt8: function() {
        var value = this.view.getUint8(this.offset);
        this.offset += 1;
        return value;
    },
    nextInt8: function() {
        var value = this.view.getInt8(this.offset);
        this.offset += 1;
        return value;
    },
    nextUInt16: function() {
        var value = this.view.getUint16(this.offset, this.littleEndian);
        this.offset += 2;
        return value;
    },
    nextUInt32: function() {
        var value = this.view.getUint32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    },
    nextInt16: function() {
        var value = this.view.getInt16(this.offset, this.littleEndian);
        this.offset += 2;
        return value;
    },
    nextInt32: function() {
        var value = this.view.getInt32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    },
    nextFloat: function() {
        var value = this.view.getFloat32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    },
    nextDouble: function() {
        var value = this.view.getFloat64(this.offset, this.littleEndian);
        this.offset += 8;
        return value;
    },
    nextBuffer: function(length) {
        //this won't work in IE10
        var value = this.arrayBuffer.slice(this.offset, this.offset + length);
        this.offset += length;
        return value;
    },
    remainingLength: function() {
        return this.arrayBuffer.byteLength - this.offset;
    },
    nextString: function(length) {
        var value = this.arrayBuffer.slice(this.offset, this.offset + length);
        value = String.fromCharCode.apply(null, new this.global.Uint8Array(value));
        this.offset += length;
        return value;
    },
    mark: function() {
        var self = this;
        return {
            openWithOffset: function(offset) {
                offset = (offset || 0) + this.offset; // Removed character.
                return new DOMBufferStream(self.arrayBuffer, offset, self.arrayBuffer.byteLength - offset, !self.littleEndian, self.global, self.parentOffset);
            },
            offset: this.offset,
            getParentOffset: function() {
                return self.parentOffset;
            }
        };
    },
    offsetFrom: function(marker) {
        return this.parentOffset + this.offset - (marker.offset + marker.getParentOffset());
    },
    skip: function(amount) {
        this.offset += amount;
    },
    branch: function(offset, length) {
        length = typeof length === 'number' ? length : this.arrayBuffer.byteLength - (this.offset + offset);
        return new DOMBufferStream(this.arrayBuffer, this.offset + offset, length, !this.littleEndian, this.global, this.parentOffset);
    }
};

module.exports = DOMBufferStream;
},{}],9:[function(_dereq_,module,exports){
module.exports = {
    exif : {
        0x0001 : "InteropIndex",
        0x0002 : "InteropVersion",
        0x000B : "ProcessingSoftware",
        0x00FE : "SubfileType",
        0x00FF : "OldSubfileType",
        0x0100 : "ImageWidth",
        0x0101 : "ImageHeight",
        0x0102 : "BitsPerSample",
        0x0103 : "Compression",
        0x0106 : "PhotometricInterpretation",
        0x0107 : "Thresholding",
        0x0108 : "CellWidth",
        0x0109 : "CellLength",
        0x010A : "FillOrder",
        0x010D : "DocumentName",
        0x010E : "ImageDescription",
        0x010F : "Make",
        0x0110 : "Model",
        0x0111 : "StripOffsets",
        0x0112 : "Orientation",
        0x0115 : "SamplesPerPixel",
        0x0116 : "RowsPerStrip",
        0x0117 : "StripByteCounts",
        0x0118 : "MinSampleValue",
        0x0119 : "MaxSampleValue",
        0x011A : "XResolution",
        0x011B : "YResolution",
        0x011C : "PlanarConfiguration",
        0x011D : "PageName",
        0x011E : "XPosition",
        0x011F : "YPosition",
        0x0120 : "FreeOffsets",
        0x0121 : "FreeByteCounts",
        0x0122 : "GrayResponseUnit",
        0x0123 : "GrayResponseCurve",
        0x0124 : "T4Options",
        0x0125 : "T6Options",
        0x0128 : "ResolutionUnit",
        0x0129 : "PageNumber",
        0x012C : "ColorResponseUnit",
        0x012D : "TransferFunction",
        0x0131 : "Software",
        0x0132 : "ModifyDate",
        0x013B : "Artist",
        0x013C : "HostComputer",
        0x013D : "Predictor",
        0x013E : "WhitePoint",
        0x013F : "PrimaryChromaticities",
        0x0140 : "ColorMap",
        0x0141 : "HalftoneHints",
        0x0142 : "TileWidth",
        0x0143 : "TileLength",
        0x0144 : "TileOffsets",
        0x0145 : "TileByteCounts",
        0x0146 : "BadFaxLines",
        0x0147 : "CleanFaxData",
        0x0148 : "ConsecutiveBadFaxLines",
        0x014A : "SubIFD",
        0x014C : "InkSet",
        0x014D : "InkNames",
        0x014E : "NumberofInks",
        0x0150 : "DotRange",
        0x0151 : "TargetPrinter",
        0x0152 : "ExtraSamples",
        0x0153 : "SampleFormat",
        0x0154 : "SMinSampleValue",
        0x0155 : "SMaxSampleValue",
        0x0156 : "TransferRange",
        0x0157 : "ClipPath",
        0x0158 : "XClipPathUnits",
        0x0159 : "YClipPathUnits",
        0x015A : "Indexed",
        0x015B : "JPEGTables",
        0x015F : "OPIProxy",
        0x0190 : "GlobalParametersIFD",
        0x0191 : "ProfileType",
        0x0192 : "FaxProfile",
        0x0193 : "CodingMethods",
        0x0194 : "VersionYear",
        0x0195 : "ModeNumber",
        0x01B1 : "Decode",
        0x01B2 : "DefaultImageColor",
        0x01B3 : "T82Options",
        0x01B5 : "JPEGTables",
        0x0200 : "JPEGProc",
        0x0201 : "ThumbnailOffset",
        0x0202 : "ThumbnailLength",
        0x0203 : "JPEGRestartInterval",
        0x0205 : "JPEGLosslessPredictors",
        0x0206 : "JPEGPointTransforms",
        0x0207 : "JPEGQTables",
        0x0208 : "JPEGDCTables",
        0x0209 : "JPEGACTables",
        0x0211 : "YCbCrCoefficients",
        0x0212 : "YCbCrSubSampling",
        0x0213 : "YCbCrPositioning",
        0x0214 : "ReferenceBlackWhite",
        0x022F : "StripRowCounts",
        0x02BC : "ApplicationNotes",
        0x03E7 : "USPTOMiscellaneous",
        0x1000 : "RelatedImageFileFormat",
        0x1001 : "RelatedImageWidth",
        0x1002 : "RelatedImageHeight",
        0x4746 : "Rating",
        0x4747 : "XP_DIP_XML",
        0x4748 : "StitchInfo",
        0x4749 : "RatingPercent",
        0x800D : "ImageID",
        0x80A3 : "WangTag1",
        0x80A4 : "WangAnnotation",
        0x80A5 : "WangTag3",
        0x80A6 : "WangTag4",
        0x80E3 : "Matteing",
        0x80E4 : "DataType",
        0x80E5 : "ImageDepth",
        0x80E6 : "TileDepth",
        0x827D : "Model2",
        0x828D : "CFARepeatPatternDim",
        0x828E : "CFAPattern2",
        0x828F : "BatteryLevel",
        0x8290 : "KodakIFD",
        0x8298 : "Copyright",
        0x829A : "ExposureTime",
        0x829D : "FNumber",
        0x82A5 : "MDFileTag",
        0x82A6 : "MDScalePixel",
        0x82A7 : "MDColorTable",
        0x82A8 : "MDLabName",
        0x82A9 : "MDSampleInfo",
        0x82AA : "MDPrepDate",
        0x82AB : "MDPrepTime",
        0x82AC : "MDFileUnits",
        0x830E : "PixelScale",
        0x8335 : "AdventScale",
        0x8336 : "AdventRevision",
        0x835C : "UIC1Tag",
        0x835D : "UIC2Tag",
        0x835E : "UIC3Tag",
        0x835F : "UIC4Tag",
        0x83BB : "IPTC-NAA",
        0x847E : "IntergraphPacketData",
        0x847F : "IntergraphFlagRegisters",
        0x8480 : "IntergraphMatrix",
        0x8481 : "INGRReserved",
        0x8482 : "ModelTiePoint",
        0x84E0 : "Site",
        0x84E1 : "ColorSequence",
        0x84E2 : "IT8Header",
        0x84E3 : "RasterPadding",
        0x84E4 : "BitsPerRunLength",
        0x84E5 : "BitsPerExtendedRunLength",
        0x84E6 : "ColorTable",
        0x84E7 : "ImageColorIndicator",
        0x84E8 : "BackgroundColorIndicator",
        0x84E9 : "ImageColorValue",
        0x84EA : "BackgroundColorValue",
        0x84EB : "PixelIntensityRange",
        0x84EC : "TransparencyIndicator",
        0x84ED : "ColorCharacterization",
        0x84EE : "HCUsage",
        0x84EF : "TrapIndicator",
        0x84F0 : "CMYKEquivalent",
        0x8546 : "SEMInfo",
        0x8568 : "AFCP_IPTC",
        0x85B8 : "PixelMagicJBIGOptions",
        0x85D8 : "ModelTransform",
        0x8602 : "WB_GRGBLevels",
        0x8606 : "LeafData",
        0x8649 : "PhotoshopSettings",
        0x8769 : "ExifOffset",
        0x8773 : "ICC_Profile",
        0x877F : "TIFF_FXExtensions",
        0x8780 : "MultiProfiles",
        0x8781 : "SharedData",
        0x8782 : "T88Options",
        0x87AC : "ImageLayer",
        0x87AF : "GeoTiffDirectory",
        0x87B0 : "GeoTiffDoubleParams",
        0x87B1 : "GeoTiffAsciiParams",
        0x8822 : "ExposureProgram",
        0x8824 : "SpectralSensitivity",
        0x8825 : "GPSInfo",
        0x8827 : "ISO",
        0x8828 : "Opto-ElectricConvFactor",
        0x8829 : "Interlace",
        0x882A : "TimeZoneOffset",
        0x882B : "SelfTimerMode",
        0x8830 : "SensitivityType",
        0x8831 : "StandardOutputSensitivity",
        0x8832 : "RecommendedExposureIndex",
        0x8833 : "ISOSpeed",
        0x8834 : "ISOSpeedLatitudeyyy",
        0x8835 : "ISOSpeedLatitudezzz",
        0x885C : "FaxRecvParams",
        0x885D : "FaxSubAddress",
        0x885E : "FaxRecvTime",
        0x888A : "LeafSubIFD",
        0x9000 : "ExifVersion",
        0x9003 : "DateTimeOriginal",
        0x9004 : "CreateDate",
        0x9101 : "ComponentsConfiguration",
        0x9102 : "CompressedBitsPerPixel",
        0x9201 : "ShutterSpeedValue",
        0x9202 : "ApertureValue",
        0x9203 : "BrightnessValue",
        0x9204 : "ExposureCompensation",
        0x9205 : "MaxApertureValue",
        0x9206 : "SubjectDistance",
        0x9207 : "MeteringMode",
        0x9208 : "LightSource",
        0x9209 : "Flash",
        0x920A : "FocalLength",
        0x920B : "FlashEnergy",
        0x920C : "SpatialFrequencyResponse",
        0x920D : "Noise",
        0x920E : "FocalPlaneXResolution",
        0x920F : "FocalPlaneYResolution",
        0x9210 : "FocalPlaneResolutionUnit",
        0x9211 : "ImageNumber",
        0x9212 : "SecurityClassification",
        0x9213 : "ImageHistory",
        0x9214 : "SubjectArea",
        0x9215 : "ExposureIndex",
        0x9216 : "TIFF-EPStandardID",
        0x9217 : "SensingMethod",
        0x923A : "CIP3DataFile",
        0x923B : "CIP3Sheet",
        0x923C : "CIP3Side",
        0x923F : "StoNits",
        0x927C : "MakerNote",
        0x9286 : "UserComment",
        0x9290 : "SubSecTime",
        0x9291 : "SubSecTimeOriginal",
        0x9292 : "SubSecTimeDigitized",
        0x932F : "MSDocumentText",
        0x9330 : "MSPropertySetStorage",
        0x9331 : "MSDocumentTextPosition",
        0x935C : "ImageSourceData",
        0x9C9B : "XPTitle",
        0x9C9C : "XPComment",
        0x9C9D : "XPAuthor",
        0x9C9E : "XPKeywords",
        0x9C9F : "XPSubject",
        0xA000 : "FlashpixVersion",
        0xA001 : "ColorSpace",
        0xA002 : "ExifImageWidth",
        0xA003 : "ExifImageHeight",
        0xA004 : "RelatedSoundFile",
        0xA005 : "InteropOffset",
        0xA20B : "FlashEnergy",
        0xA20C : "SpatialFrequencyResponse",
        0xA20D : "Noise",
        0xA20E : "FocalPlaneXResolution",
        0xA20F : "FocalPlaneYResolution",
        0xA210 : "FocalPlaneResolutionUnit",
        0xA211 : "ImageNumber",
        0xA212 : "SecurityClassification",
        0xA213 : "ImageHistory",
        0xA214 : "SubjectLocation",
        0xA215 : "ExposureIndex",
        0xA216 : "TIFF-EPStandardID",
        0xA217 : "SensingMethod",
        0xA300 : "FileSource",
        0xA301 : "SceneType",
        0xA302 : "CFAPattern",
        0xA401 : "CustomRendered",
        0xA402 : "ExposureMode",
        0xA403 : "WhiteBalance",
        0xA404 : "DigitalZoomRatio",
        0xA405 : "FocalLengthIn35mmFormat",
        0xA406 : "SceneCaptureType",
        0xA407 : "GainControl",
        0xA408 : "Contrast",
        0xA409 : "Saturation",
        0xA40A : "Sharpness",
        0xA40B : "DeviceSettingDescription",
        0xA40C : "SubjectDistanceRange",
        0xA420 : "ImageUniqueID",
        0xA430 : "OwnerName",
        0xA431 : "SerialNumber",
        0xA432 : "LensInfo",
        0xA433 : "LensMake",
        0xA434 : "LensModel",
        0xA435 : "LensSerialNumber",
        0xA480 : "GDALMetadata",
        0xA481 : "GDALNoData",
        0xA500 : "Gamma",
        0xAFC0 : "ExpandSoftware",
        0xAFC1 : "ExpandLens",
        0xAFC2 : "ExpandFilm",
        0xAFC3 : "ExpandFilterLens",
        0xAFC4 : "ExpandScanner",
        0xAFC5 : "ExpandFlashLamp",
        0xBC01 : "PixelFormat",
        0xBC02 : "Transformation",
        0xBC03 : "Uncompressed",
        0xBC04 : "ImageType",
        0xBC80 : "ImageWidth",
        0xBC81 : "ImageHeight",
        0xBC82 : "WidthResolution",
        0xBC83 : "HeightResolution",
        0xBCC0 : "ImageOffset",
        0xBCC1 : "ImageByteCount",
        0xBCC2 : "AlphaOffset",
        0xBCC3 : "AlphaByteCount",
        0xBCC4 : "ImageDataDiscard",
        0xBCC5 : "AlphaDataDiscard",
        0xC427 : "OceScanjobDesc",
        0xC428 : "OceApplicationSelector",
        0xC429 : "OceIDNumber",
        0xC42A : "OceImageLogic",
        0xC44F : "Annotations",
        0xC4A5 : "PrintIM",
        0xC580 : "USPTOOriginalContentType",
        0xC612 : "DNGVersion",
        0xC613 : "DNGBackwardVersion",
        0xC614 : "UniqueCameraModel",
        0xC615 : "LocalizedCameraModel",
        0xC616 : "CFAPlaneColor",
        0xC617 : "CFALayout",
        0xC618 : "LinearizationTable",
        0xC619 : "BlackLevelRepeatDim",
        0xC61A : "BlackLevel",
        0xC61B : "BlackLevelDeltaH",
        0xC61C : "BlackLevelDeltaV",
        0xC61D : "WhiteLevel",
        0xC61E : "DefaultScale",
        0xC61F : "DefaultCropOrigin",
        0xC620 : "DefaultCropSize",
        0xC621 : "ColorMatrix1",
        0xC622 : "ColorMatrix2",
        0xC623 : "CameraCalibration1",
        0xC624 : "CameraCalibration2",
        0xC625 : "ReductionMatrix1",
        0xC626 : "ReductionMatrix2",
        0xC627 : "AnalogBalance",
        0xC628 : "AsShotNeutral",
        0xC629 : "AsShotWhiteXY",
        0xC62A : "BaselineExposure",
        0xC62B : "BaselineNoise",
        0xC62C : "BaselineSharpness",
        0xC62D : "BayerGreenSplit",
        0xC62E : "LinearResponseLimit",
        0xC62F : "CameraSerialNumber",
        0xC630 : "DNGLensInfo",
        0xC631 : "ChromaBlurRadius",
        0xC632 : "AntiAliasStrength",
        0xC633 : "ShadowScale",
        0xC634 : "DNGPrivateData",
        0xC635 : "MakerNoteSafety",
        0xC640 : "RawImageSegmentation",
        0xC65A : "CalibrationIlluminant1",
        0xC65B : "CalibrationIlluminant2",
        0xC65C : "BestQualityScale",
        0xC65D : "RawDataUniqueID",
        0xC660 : "AliasLayerMetadata",
        0xC68B : "OriginalRawFileName",
        0xC68C : "OriginalRawFileData",
        0xC68D : "ActiveArea",
        0xC68E : "MaskedAreas",
        0xC68F : "AsShotICCProfile",
        0xC690 : "AsShotPreProfileMatrix",
        0xC691 : "CurrentICCProfile",
        0xC692 : "CurrentPreProfileMatrix",
        0xC6BF : "ColorimetricReference",
        0xC6D2 : "PanasonicTitle",
        0xC6D3 : "PanasonicTitle2",
        0xC6F3 : "CameraCalibrationSig",
        0xC6F4 : "ProfileCalibrationSig",
        0xC6F5 : "ProfileIFD",
        0xC6F6 : "AsShotProfileName",
        0xC6F7 : "NoiseReductionApplied",
        0xC6F8 : "ProfileName",
        0xC6F9 : "ProfileHueSatMapDims",
        0xC6FA : "ProfileHueSatMapData1",
        0xC6FB : "ProfileHueSatMapData2",
        0xC6FC : "ProfileToneCurve",
        0xC6FD : "ProfileEmbedPolicy",
        0xC6FE : "ProfileCopyright",
        0xC714 : "ForwardMatrix1",
        0xC715 : "ForwardMatrix2",
        0xC716 : "PreviewApplicationName",
        0xC717 : "PreviewApplicationVersion",
        0xC718 : "PreviewSettingsName",
        0xC719 : "PreviewSettingsDigest",
        0xC71A : "PreviewColorSpace",
        0xC71B : "PreviewDateTime",
        0xC71C : "RawImageDigest",
        0xC71D : "OriginalRawFileDigest",
        0xC71E : "SubTileBlockSize",
        0xC71F : "RowInterleaveFactor",
        0xC725 : "ProfileLookTableDims",
        0xC726 : "ProfileLookTableData",
        0xC740 : "OpcodeList1",
        0xC741 : "OpcodeList2",
        0xC74E : "OpcodeList3",
        0xC761 : "NoiseProfile",
        0xC763 : "TimeCodes",
        0xC764 : "FrameRate",
        0xC772 : "TStop",
        0xC789 : "ReelName",
        0xC791 : "OriginalDefaultFinalSize",
        0xC792 : "OriginalBestQualitySize",
        0xC793 : "OriginalDefaultCropSize",
        0xC7A1 : "CameraLabel",
        0xC7A3 : "ProfileHueSatMapEncoding",
        0xC7A4 : "ProfileLookTableEncoding",
        0xC7A5 : "BaselineExposureOffset",
        0xC7A6 : "DefaultBlackRender",
        0xC7A7 : "NewRawImageDigest",
        0xC7A8 : "RawToPreviewGain",
        0xC7B5 : "DefaultUserCrop",
        0xEA1C : "Padding",
        0xEA1D : "OffsetSchema",
        0xFDE8 : "OwnerName",
        0xFDE9 : "SerialNumber",
        0xFDEA : "Lens",
        0xFE00 : "KDC_IFD",
        0xFE4C : "RawFile",
        0xFE4D : "Converter",
        0xFE4E : "WhiteBalance",
        0xFE51 : "Exposure",
        0xFE52 : "Shadows",
        0xFE53 : "Brightness",
        0xFE54 : "Contrast",
        0xFE55 : "Saturation",
        0xFE56 : "Sharpness",
        0xFE57 : "Smoothness",
        0xFE58 : "MoireFilter"
        
    },
    gps : {	
        0x0000 : 'GPSVersionID',
        0x0001 : 'GPSLatitudeRef',
        0x0002 : 'GPSLatitude',
        0x0003 : 'GPSLongitudeRef',
        0x0004 : 'GPSLongitude',
        0x0005 : 'GPSAltitudeRef',
        0x0006 : 'GPSAltitude',
        0x0007 : 'GPSTimeStamp',
        0x0008 : 'GPSSatellites',
        0x0009 : 'GPSStatus',
        0x000A : 'GPSMeasureMode',
        0x000B : 'GPSDOP',
        0x000C : 'GPSSpeedRef',
        0x000D : 'GPSSpeed',
        0x000E : 'GPSTrackRef',
        0x000F : 'GPSTrack',
        0x0010 : 'GPSImgDirectionRef',
        0x0011 : 'GPSImgDirection',
        0x0012 : 'GPSMapDatum',
        0x0013 : 'GPSDestLatitudeRef',
        0x0014 : 'GPSDestLatitude',
        0x0015 : 'GPSDestLongitudeRef',
        0x0016 : 'GPSDestLongitude',
        0x0017 : 'GPSDestBearingRef',
        0x0018 : 'GPSDestBearing',
        0x0019 : 'GPSDestDistanceRef',
        0x001A : 'GPSDestDistance',
        0x001B : 'GPSProcessingMethod',
        0x001C : 'GPSAreaInformation',
        0x001D : 'GPSDateStamp',
        0x001E : 'GPSDifferential',
        0x001F : 'GPSHPositioningError'
    }
};
},{}],10:[function(_dereq_,module,exports){
/*jslint browser: true, devel: true, bitwise: false, debug: true, eqeq: false, es5: true, evil: false, forin: false, newcap: false, nomen: true, plusplus: true, regexp: false, unparam: false, sloppy: true, stupid: false, sub: false, todo: true, vars: true, white: true */

function readExifValue(format, stream) {
    switch(format) {
        case 1: return stream.nextUInt8();
        case 3: return stream.nextUInt16();
        case 4: return stream.nextUInt32();
        case 5: return [stream.nextUInt32(), stream.nextUInt32()];
        case 6: return stream.nextInt8();
        case 8: return stream.nextUInt16();
        case 9: return stream.nextUInt32();
        case 10: return [stream.nextInt32(), stream.nextInt32()];
        case 11: return stream.nextFloat();
        case 12: return stream.nextDouble();
        default: throw new Error('Invalid format while decoding: ' + format);
    }
}

function getBytesPerComponent(format) {
    switch(format) {
        case 1:
        case 2:
        case 6:
        case 7:
            return 1;
        case 3:
        case 8:
            return 2;
        case 4:
        case 9:
        case 11:
            return 4;
        case 5:
        case 10:
        case 12:
            return 8;
        default:
            throw new Error('Invalid format: ' + format);
    }
}

function readExifTag(tiffMarker, stream) {
    var tagType = stream.nextUInt16(),
        format = stream.nextUInt16(),
        bytesPerComponent = getBytesPerComponent(format),
        components = stream.nextUInt32(),
        valueBytes = bytesPerComponent * components,
        values,
        value,
        c;

    /* if the value is bigger then 4 bytes, the value is in the data section of the IFD
    and the value present in the tag is the offset starting from the tiff header. So we replace the stream
    with a stream that is located at the given offset in the data section. s*/
    if(valueBytes > 4) {
        stream = tiffMarker.openWithOffset(stream.nextUInt32());
    }
    //we don't want to read strings as arrays
    if(format === 2) {
        values = stream.nextString(components);
        //cut off \0 characters
        var lastNull = values.indexOf('\0');
        if(lastNull !== -1) {
            values = values.substr(0, lastNull);
        }
    }
    else if(format === 7) {
        values = stream.nextBuffer(components);
    }
    else {
        values = [];
        for(c = 0; c < components; ++c) {
            values.push(readExifValue(format, stream));
        }
    }
    //since our stream is a stateful object, we need to skip remaining bytes
    //so our offset stays correct
    if(valueBytes < 4) {
        stream.skip(4 - valueBytes);
    }

    return [tagType, values, format];
}

function readIFDSection(tiffMarker, stream, iterator) {
    var numberOfEntries = stream.nextUInt16(), tag, i;
    for(i = 0; i < numberOfEntries; ++i) {
        tag = readExifTag(tiffMarker, stream);
        iterator(tag[0], tag[1], tag[2]);
    }
}

function readHeader(stream) {
    var exifHeader = stream.nextString(6);
    if(exifHeader !== 'Exif\0\0') {
        throw new Error('Invalid EXIF header');
    }

    var tiffMarker = stream.mark();
    var tiffHeader = stream.nextUInt16();
    if(tiffHeader === 0x4949) {
        stream.setBigEndian(false);
    } else if(tiffHeader === 0x4D4D) {
        stream.setBigEndian(true);
    } else {
        throw new Error('Invalid TIFF header');
    }
    if(stream.nextUInt16() !== 0x002A) {
        throw new Error('Invalid TIFF data');
    }
    return tiffMarker;
}

module.exports = {
    IFD0: 1,
    IFD1: 2,
    GPSIFD: 3,
    SubIFD: 4,
    InteropIFD: 5,
    parseTags: function(stream, iterator) {
        var tiffMarker;
        try {
            tiffMarker = readHeader(stream);
        } catch(e) {
            return false;	//ignore APP1 sections with invalid headers
        }
        var subIfdOffset, gpsOffset, interopOffset;
        var ifd0Stream = tiffMarker.openWithOffset(stream.nextUInt32()),
            IFD0 = this.IFD0;
        readIFDSection(tiffMarker, ifd0Stream, function(tagType, value, format) {
            switch(tagType) {
                case 0x8825: gpsOffset = value[0]; break;
                case 0x8769: subIfdOffset = value[0]; break;
                default: iterator(IFD0, tagType, value, format); break;
            }
        });
        var ifd1Offset = ifd0Stream.nextUInt32();
        if(ifd1Offset !== 0) {
            var ifd1Stream = tiffMarker.openWithOffset(ifd1Offset);
            readIFDSection(tiffMarker, ifd1Stream, iterator.bind(null, this.IFD1));
        }

        if(gpsOffset) {
            var gpsStream = tiffMarker.openWithOffset(gpsOffset);
            readIFDSection(tiffMarker, gpsStream, iterator.bind(null, this.GPSIFD));
        }

        if(subIfdOffset) {
            var subIfdStream = tiffMarker.openWithOffset(subIfdOffset), InteropIFD = this.InteropIFD;
            readIFDSection(tiffMarker, subIfdStream, function(tagType, value, format) {
                if(tagType === 0xA005) {
                    interopOffset = value[0];
                } else {
                    iterator(InteropIFD, tagType, value, format);
                }
            });
        }

        if(interopOffset) {
            var interopStream = tiffMarker.openWithOffset(interopOffset);
            readIFDSection(tiffMarker, interopStream, iterator.bind(null, this.InteropIFD));
        }
        return true;
    }
};
},{}],11:[function(_dereq_,module,exports){
/*jslint browser: true, devel: true, bitwise: false, debug: true, eqeq: false, es5: true, evil: false, forin: false, newcap: false, nomen: true, plusplus: true, regexp: false, unparam: false, sloppy: true, stupid: false, sub: false, todo: true, vars: true, white: true */

module.exports = {
    parseSections: function(stream, iterator) {
        var len, markerType;
        stream.setBigEndian(true);
        //stop reading the stream at the SOS (Start of Stream) marker,
        //because its length is not stored in the header so we can't
        //know where to jump to. The only marker after that is just EOI (End Of Image) anyway
        while(stream.remainingLength() > 0 && markerType !== 0xDA) {
            if(stream.nextUInt8() !== 0xFF) {
                throw new Error('Invalid JPEG section offset');
            }
            markerType = stream.nextUInt8();
            //don't read size from markers that have no datas
            if((markerType >= 0xD0 && markerType <= 0xD9) || markerType === 0xDA) {
                len = 0;
            } else {
                len = stream.nextUInt16() - 2;
            }
            iterator(markerType, stream.branch(0, len));
            stream.skip(len);
        }
    },
    //stream should be located after SOF section size and in big endian mode, like passed to parseSections iterator
    getSizeFromSOFSection: function(stream) {
        stream.skip(1);
        return {
            height: stream.nextUInt16(),
            width: stream.nextUInt16()
        };
    },
    getSectionName: function(markerType) {
        var name, index;
        switch(markerType) {
            case 0xD8: name = 'SOI'; break;
            case 0xC4: name = 'DHT'; break;
            case 0xDB: name = 'DQT'; break;
            case 0xDD: name = 'DRI'; break;
            case 0xDA: name = 'SOS'; break;
            case 0xFE: name = 'COM'; break;
            case 0xD9: name = 'EOI'; break;
            default:
                if(markerType >= 0xE0 && markerType <= 0xEF) {
                    name = 'APP';
                    index = markerType - 0xE0;
                }
                else if(markerType >= 0xC0 && markerType <= 0xCF && markerType !== 0xC4 && markerType !== 0xC8 && markerType !== 0xCC) {
                    name = 'SOF';
                    index = markerType - 0xC0;
                }
                else if(markerType >= 0xD0 && markerType <= 0xD7) {
                    name = 'RST';
                    index = markerType - 0xD0;
                }
                break;
        }
        var nameStruct = {
            name: name
        };
        if(typeof index === 'number') {
            nameStruct.index = index;
        }
        return nameStruct;
    }
};
},{}],12:[function(_dereq_,module,exports){
/*jslint browser: true, devel: true, bitwise: false, debug: true, eqeq: false, es5: true, evil: false, forin: false, newcap: false, nomen: true, plusplus: true, regexp: false, unparam: false, sloppy: true, stupid: false, sub: false, todo: true, vars: true, white: true */

var assert = _dereq_('assert');
var jpeg = _dereq_('./jpeg'),
    exif = _dereq_('./exif'),
    simplify = _dereq_('./simplify');

function ExifResult(startMarker, tags, imageSize, thumbnailOffset, thumbnailLength, thumbnailType, app1Offset) {
    this.startMarker = startMarker;
    this.tags = tags;
    this.imageSize = imageSize;
    this.thumbnailOffset = thumbnailOffset;
    this.thumbnailLength = thumbnailLength;
    this.thumbnailType = thumbnailType;
    this.app1Offset = app1Offset;
}

ExifResult.prototype = {
    hasThumbnail: function(mime) {
        if(!this.thumbnailOffset || !this.thumbnailLength) {
            return false;
        }
        if(typeof mime !== 'string') {
            return true;
        }
        if(mime.toLowerCase().trim() === 'image/jpeg') {
            return this.thumbnailType === 6;
        }
        if(mime.toLowerCase().trim() === 'image/tiff') {
            return this.thumbnailType === 1;
        }
        return false;
    },
    getThumbnailOffset: function() {
        return this.app1Offset + 6 + this.thumbnailOffset;
    },
    getThumbnailLength: function() {
        return this.thumbnailLength;
    },
    getThumbnailBuffer: function() {
        return this._getThumbnailStream().nextBuffer(this.thumbnailLength);
    },
    _getThumbnailStream: function() {
        return this.startMarker.openWithOffset(this.getThumbnailOffset());
    },
    getImageSize: function() {
        return this.imageSize;
    },
    getThumbnailSize: function() {
        var stream = this._getThumbnailStream(), size;
        jpeg.parseSections(stream, function(sectionType, sectionStream) {
            if(jpeg.getSectionName(sectionType).name === 'SOF') {
                size = jpeg.getSizeFromSOFSection(sectionStream);
            }
        });
        return size;
    }
};

function Parser(stream) {
    this.stream = stream;
    this.flags = {
        readBinaryTags: false,
        resolveTagNames: true,
        simplifyValues: true,
        imageSize: true,
        hidePointers: true,
        returnTags: true
    };
}

Parser.prototype = {
    enableBinaryFields: function(enable) {
        this.flags.readBinaryTags = !!enable;
        return this;
    },
    enablePointers: function(enable) {
        this.flags.hidePointers = !enable;
        return this;
    },
    enableTagNames: function(enable) {
        this.flags.resolveTagNames = !!enable;
        return this;
    },
    enableImageSize: function(enable) {
        this.flags.imageSize = !!enable;
        return this;
    },
    enableReturnTags: function(enable) {
        this.flags.returnTags = !!enable;
        return this;
    },
    enableSimpleValues: function(enable) {
        this.flags.simplifyValues = !!enable;
        return this;
    },
    parse: function() {
        var start = this.stream.mark(),
            stream = start.openWithOffset(0),
            flags = this.flags,
            tags,
            imageSize,
            thumbnailOffset,
            thumbnailLength,
            thumbnailType,
            app1Offset,
            tagNames,
            getTagValue, setTagValue;
        if(flags.resolveTagNames) {
            tagNames = _dereq_('./exif-tags');
        }
        if(flags.resolveTagNames) {
            tags = {};
            getTagValue = function(t) {
                return tags[t.name];
            };
            setTagValue = function(t, value) {
                tags[t.name] = value;
            };
        } else {
            tags = [];
            getTagValue = function(t) {
                var i;
                for(i = 0; i < tags.length; ++i) {
                    if(tags[i].type === t.type && tags[i].section === t.section) {
                        return tags.value;
                    }
                }
            };
            setTagValue = function(t, value) {
                var i;
                for(i = 0; i < tags.length; ++i) {
                    if(tags[i].type === t.type && tags[i].section === t.section) {
                        tags.value = value;
                        return;
                    }
                }
            };
        }
        
        jpeg.parseSections(stream, function(sectionType, sectionStream) {
            var validExifHeaders, sectionOffset = sectionStream.offsetFrom(start);
            if(sectionType === 0xE1) {
                validExifHeaders = exif.parseTags(sectionStream, function(ifdSection, tagType, value, format) {
                    //ignore binary fields if disabled
                    if(!flags.readBinaryTags && format === 7) {
                        return;
                    }

                    if(tagType === 0x0201) {
                        thumbnailOffset = value[0];
                        if(flags.hidePointers) {return;}
                    } else if(tagType === 0x0202) {
                        thumbnailLength = value[0];
                        if(flags.hidePointers) {return;}
                    } else if(tagType === 0x0103) {
                        thumbnailType = value[0];
                        if(flags.hidePointers) {return;}
                    }
                    //if flag is set to not store tags, return here after storing pointers
                    if(!flags.returnTags) {
                        return;
                    }

                    if(flags.simplifyValues) {
                        value = simplify.simplifyValue(value, format);
                    }
                    if(flags.resolveTagNames) {
                        var sectionTagNames = ifdSection === exif.GPSIFD ? tagNames.gps : tagNames.exif;
                        var name = sectionTagNames[tagType];
                        if(!name) {
                            name = tagNames.exif[tagType];
                        }
                        tags[name] = value;
                    } else {
                        tags.push({
                            section: ifdSection,
                            type: tagType,
                            value: value
                        });
                    }
                });
                if(validExifHeaders) {
                    app1Offset = sectionOffset;
                }
            }
            else if(flags.imageSize && jpeg.getSectionName(sectionType).name === 'SOF') {
                imageSize = jpeg.getSizeFromSOFSection(sectionStream);
            }
        });

        if(flags.simplifyValues) {
            simplify.castDegreeValues(getTagValue, setTagValue);
            simplify.castDateValues(getTagValue, setTagValue);
        }

        return new ExifResult(start, tags, imageSize, thumbnailOffset, thumbnailLength, thumbnailType, app1Offset);
    }
};



module.exports = Parser;
},{"./exif":10,"./exif-tags":9,"./jpeg":11,"./simplify":13,"assert":1}],13:[function(_dereq_,module,exports){
var exif = _dereq_('./exif');

var degreeTags = [{
    section: exif.GPSIFD,
    type: 0x0002,
    name: 'GPSLatitude',
    refType: 0x0001,
    refName: 'GPSLatitudeRef',
    posVal: 'N'
},
{
    section: exif.GPSIFD,
    type: 0x0004,
    name: 'GPSLongitude',
    refType: 0x0003,
    refName: 'GPSLongitudeRef',
    posVal: 'E'
}];
var dateTags = [{
    section: exif.SubIFD,
    type: 0x9003,
    name: 'DateTimeOriginal'
},
{
    section: exif.SubIFD,
    type: 0x9004,
    name: 'CreateDate'
}];

module.exports = {
    castDegreeValues: function(getTagValue, setTagValue) {
        degreeTags.forEach(function(t) {
            var degreeVal = getTagValue(t);
            if(degreeVal) {
                var degreeRef = getTagValue({section: t.section, type: t.refType, name: t.refName});
                var degreeNumRef = degreeRef === t.posVal ? 1 : -1;
                var degree = (degreeVal[0] + (degreeVal[1] / 60) + (degreeVal[2] / 3600)) * degreeNumRef;
                setTagValue(t, degree);
            }
        });
    },
    castDateValues: function(getTagValue, setTagValue) {
        dateTags.forEach(function(t) {
            var dateStrVal = getTagValue(t);
            if(dateStrVal) {
                var parts = dateStrVal.split(' '),
                    dateParts = parts[0].split(':'),
                    timeParts = parts[1].split(':');
                var date = new Date();
                date.setUTCFullYear(dateParts[0]);
                date.setUTCMonth(dateParts[1] - 1);
                date.setUTCDate(dateParts[2]);
                date.setUTCHours(timeParts[0]);
                date.setUTCMinutes(timeParts[1]);
                date.setUTCSeconds(timeParts[2]);
                date.setUTCMilliseconds(0);
                var timestamp = date.getTime() / 1000;
                setTagValue(t, timestamp);
            }
        });
    },
    simplifyValue: function(values, format) {
        if(Array.isArray(values)) {
            values = values.map(function(value) {
                if(format === 10 || format === 5) { // Removed character.
                    return value[0] / value[1];
                }
                return value;
            });
            if(values.length === 1) {
                values = values[0];
            }
        }
        return values;
    }
};
},{"./exif":10}]},{},[6])
(6)
});
